import {
  Card,
  DotComponent,
  IconComponent,
  IconsProps,
  Tooltip,
  Typography,
  TypographyType,
} from '../../../components';
import { DropdownPlacement, TextColor } from '../../../types';

const CALL_HEADER_CARD_GAP = 4;
const CALL_HEADER_CARD_HEIGHT = 102;

interface CallDetailsHeaderCardProps {
  title: string;
  value: string | number;
  description?: string;
  indicator?: DotComponent | IconComponent<Pick<IconsProps, 'icon' | 'color'>>;
  tooltip?: string;
}

const CallDetailsHeaderCard = ({ title, value, description, indicator, tooltip }: CallDetailsHeaderCardProps) => (
  <Tooltip label={tooltip} placement={DropdownPlacement.BOTTOM} className="w-full">
    <Card gap={CALL_HEADER_CARD_GAP} height={CALL_HEADER_CARD_HEIGHT} className="justify-center">
      <Typography color={TextColor.SECONDARY} type={TypographyType.X_SMALL}>
        {title}
      </Typography>
      <div className="flex items-center gap-2">
        {indicator}
        <Typography type={TypographyType.H3}>{value}</Typography>
      </div>
      <Typography color={TextColor.SECONDARY} type={TypographyType.X_SMALL} maxLines={1}>
        {description}
      </Typography>
    </Card>
  </Tooltip>
);

export default CallDetailsHeaderCard;
